import script from "./servicetable.vue?vue&type=script&setup=true&lang=js"
export * from "./servicetable.vue?vue&type=script&setup=true&lang=js"

import "./servicetable.vue?vue&type=style&index=0&id=590989de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590989de"]])

export default __exports__